export default "__VITE_ASSET__Drce27w4__"